import { z } from 'zod';

export const requestPasswordResetSchema = z.object({
  email: z.string().trim().min(1, 'Email is required').email('Please enter a valid email address'),
});

export type RequestPasswordResetValues = z.infer<typeof requestPasswordResetSchema>;
